/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownToDoubleLine: {
  name: 'arrow-down-to-double-line';
  data: string;
} = {
  name: 'arrow-down-to-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a1 1 0 0 1 1 1v6.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-.706.293H17a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h5a.997.997 0 0 1-.707-.293l-4-4a1 1 0 0 1 1.414-1.414L11 11.586V5a1 1 0 0 1 1-1ZM6 19a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
